<form [formGroup]="form">
    <table class="widget-settings_wrap">

        <!-- Widget Name -->
        <tr class="field">
            <td>
                <label class="label-text" for="widget_name">
                    {{'components.widgets.common.settings_widget_name' | l10n}}
                </label>
            </td>
            <td>
                <input class="text-input" type="text" id="widget_name" [formControl]="form.controls.title" [autofocus] />
            </td>
        </tr>

        <!-- Security -->
        <tr class="field">
            <td>
                <label class="label-text" #securityLabel>
                    {{'components.widgets.common.settings_widget_symbol' | l10n}}
                </label>
            </td>
            <td>
                <security-input
                    class="text-input"
                    [formControl]="form.controls.security"
                    [labelElement]="securityLabel">
                </security-input>
            </td>
        </tr>

        <!-- Confirmation -->
        <tr class="field">
            <td>
                <label class="label-text" for="enable_confirmation">
                    {{'components.widgets.chart-widget.enable_confirmation' | l10n}}
                </label>
            </td>
            <td>
                <label>
                    <input type="checkbox"
                           class="checkbox-input"
                           id="enable_confirmation"
                           [formControl]="form.controls.isConfirmationEnabled"/>
                    <span class="checkbox-sign"></span>
                </label>
            </td>
        </tr>
    </table>
</form>

